// utils/events.ts

/**
 * Adds an event listener to a DOM element or document.
 * @param {EventTarget} element - The element, document, or window to attach the listener to.
 * @param {string} eventType - The event type (e.g., 'click', 'mouseover').
 * @param {(event: Event) => void} handler - The function to execute when the event is triggered.
 */
export function addEventListener(
	element: EventTarget, // Changed from HTMLElement to EventTarget
	eventType: string,
	handler: (event: Event) => void,
): void {
	element.addEventListener(eventType, handler);
}

/**
 * Removes an event listener from a DOM element or document.
 * @param {EventTarget} element - The element, document, or window to remove the listener from.
 * @param {string} eventType - The event type (e.g., 'click', 'mouseover').
 * @param {(event: Event) => void} handler - The function that was attached as a listener.
 */
export function removeEventListener(
	element: EventTarget, // Changed from HTMLElement to EventTarget
	eventType: string,
	handler: (event: Event) => void,
): void {
	element.removeEventListener(eventType, handler);
}

/**
 * Prevents the default action and stops propagation of an event.
 * @param {Event} event - The event object.
 */
export function preventDefaultAndStopPropagation(event: Event): void {
	event.preventDefault();
	event.stopPropagation();
}
